import {ApiFunction, ChatbotApi} from "../chatbot/towersChatbotApi";


export class SquadflixLogsApi {
    static async logSquadflixView({tmdbId, season, episode, duration}) {
        const fn = new ApiFunction('viewingSquadflixItem', ChatbotApi.baseUrl);
        return fn.call({tmdbId, season, episode, duration});
    }

    static async getSquadflixLogs({uid, startDate, endDate, tmdbId}) {
        const fn = new ApiFunction('getViewingLogs', ChatbotApi.baseUrl);
        return fn.call({uid, startDate, endDate, tmdbId});
    }

    static async getMyViewingLogs({startDate, endDate, tmdbId}) {
        const fn = new ApiFunction('getMyViewingLogs', ChatbotApi.baseUrl);
        return fn.call({startDate, endDate, tmdbId});
    }

    static async getMyViewedItems({page}) {
        const fn = new ApiFunction('getMyViewedItems', ChatbotApi.baseUrl);
        return fn.call({page});
    }

    static async getMyNotedItems({page, query}) {
        const fn = new ApiFunction('getMyNotedItems', ChatbotApi.baseUrl);
        return fn.call({page, query});
    }
}
